import { Typography } from "@jewlr/storybook/core"
import styled from "styled-components"

export const Description = styled(Typography).attrs((props) => ({
  fontSize: 18,
  margin: "auto",
  pb: 5,
  ...props,
}))``
export const Title = styled(Typography).attrs((props) => ({
  fontSize: 25,
  mb: 3,
  ...props,
}))``
